import ApiBaseClass from "./service.api.base";

class ApiService extends ApiBaseClass {
  constructor() {
    super("clientApi");
  }
}

export default new ApiService();
